export default __webpack_public_path__ + "static/loss_travel_parabola-45a3cab7494618a6e45e20c9624ff250.mp4";